module.exports = __webpack_public_path__ + "img/v6.3200d3dd.png";